import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'

import Translations from '../Translations'

import * as SuperAdminActions from '../../ducks/super-admin'

function mapStateToProps(state) {
  return {
    currentLanguage: state.superAdmin.get('language'),
    currentPrefix: state.superAdmin.get('prefix'),
    currentTranslations: state.superAdmin.get('translations'),
    translationsInEnglish: state.superAdmin.get('translationsInEnglish')
  }
}

function mapDispatchToProps(dispatch) {
  const actions = bindActionCreators(SuperAdminActions, dispatch)

  return {
    onSelectTranslatableLanguage: actions.selectTranslatableLanguage,
    onUpdateTranslationsForLanguage: actions.updateTranslationsForLanguage
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Translations)



// WEBPACK FOOTER //
// ./src/components/smart/TranslationsContainer.js